/**
 * Normalize AFT locale to ICU locale.
 */
export function normalizeLocale(locale: string)  {
  return locale.replace(/_/, "-")                // aa_BB => aa-BB
               .replace(/^zh-CN$/, "zh-Hans-CN") // zh-CN => zh-Hans-CN confirmed with lperquin@
}
